import { t } from '../../app/i18n';

export default {
  NEBANKOVY_UVER: 'NEBANKOVY_UVER',
  BANKOVY_UVER: 'BANKOVY_UVER',
  HYPOTEKA: 'HYPOTEKA',
  LEASING: 'LEASING',
  KREDITNA_KARTA: 'KREDITNA_KARTA',
  KONTOKORENT: 'KONTOKORENT',
  INE: 'INE',
};

export const translation = {
  NEBANKOVY_UVER: t('Nebankový úver'),
  BANKOVY_UVER: t('Bankový úver'),
  HYPOTEKA: t('Hypotéka'),
  LEASING: t('Leasing'),
  KREDITNA_KARTA: t('Kreditná karta'),
  KONTOKORENT: t('Kontokorent'),
  INE: t('Iné'),
};



// WEBPACK FOOTER //
// ./src/common/enums/obligationType.js